import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Customer } from '../../../models/customer';
import { DamageCase } from '../../../models/damage-case';
import { AuthenticationService } from '../../../services/auth/authentication.service';
import { DamageCaseService } from '../../../services/damage-case.service';
import { UserService } from '../../../services/user.service';
import { DamageType } from '../../../models/damagecase/damage-type.model';
import { ApiResult } from '../../../models/api-result';
import { Address } from '../../../models/address';
// import { damageTypes } from '../../../types/mode.type';

@Component({
  selector: 'app-edit-case',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './edit-case.component.html',
  styleUrl: './edit-case.component.scss'
})
export class EditCaseComponent implements OnInit {
  @Input() model: DamageCase = new DamageCase();
  
  customers!: Customer[];
  currentCustomer!: Customer;
  damageTypes!: DamageType[];

  damageDate: string = "";

  formtitle: string;
  submitted = false;

  onSubmit() {
      this.submitted = true;
      this.saveCase();
  }

  constructor(
    private damagecaseService: DamageCaseService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    public authService: AuthenticationService,
    private userService: UserService) {

    this.formtitle = "REDIGÉR";

    this.damagecaseService.getDamageTypeList()
      .subscribe((response: ApiResult<DamageType[]>) => {
        if (response.success === true) {
          this.damageTypes = response.result.filter(damageType => damageType.active);
        }
      })
  }

  getUsers(): void {
    this.userService.getCustomers()
      .subscribe((dcresult: Customer[]) => this.customers = dcresult);
  }

  ngOnInit(): void {
    // Format damageDate for input[type="date"]
    if (this.model.damageDate) {
      const date = new Date(this.model.damageDate);
      const yyyy = date.getFullYear();
      const mm = ('0' + (date.getMonth() + 1)).slice(-2);
      const dd = ('0' + date.getDate()).slice(-2);
      this.damageDate = `${yyyy}-${mm}-${dd}`;
    }

    // Load customers list
    this.getUsers();

    // Load damage types
    this.damagecaseService.getDamageTypeList()
      .subscribe((response: ApiResult<DamageType[]>) => {
        if (response.success) {
          this.damageTypes = response.result.filter(dt => dt.active);
        }
      });
  }

  disableTyping(event: KeyboardEvent): void {
    event.preventDefault();  // Prevents keyboard input
  }

  saveCase() {
    //this.model.damageDate = new Date(this.damageDate);

    this.damagecaseService.update(this.model)
      .subscribe((dc: DamageCase) => this.router.navigate(["case", this.model.id]));
  }

  customerChange(newValue: any) {
      const currentCustomer: Customer | undefined = this.customers.find(c => c.id === newValue.value);

      if (currentCustomer) {
          // Ensure damageAddress exists
          if (!this.model.damageAddress) {
              this.model.damageAddress = {
                  street: '',
                  city: '',
                  zip: '',
                  country: ''
              };
          }

          this.model.damageAddress.street = currentCustomer.address.street;
          this.model.damageAddress.city = currentCustomer.address.city;
          this.model.damageAddress.zip = currentCustomer.address.zip;
          this.model.damageAddress.country = currentCustomer.address.country;
      }
  }

  onCancel(event: MouseEvent): void {
      event.preventDefault();
      this.router.navigate(["case", this.model.id]);
  }
}
